module.exports.CONSOLE_VERSION = '6.10.0.2'
module.exports.WI_CONSOLE_VERSION = '1.3.0.146'
